// extracted by mini-css-extract-plugin
module.exports = {"subCopy":"what-we-do_subCopy__lkfzL"};